// removed by extract-text-webpack-plugin
module.exports = {"projects":"Projects__projects___Iv8iE","pageTitle":"Projects__pageTitle___1gEZZ","pageSubTitle":"Projects__pageSubTitle___jLPy4","divider":"Projects__divider___6DRBl","top":"Projects__top___3WsYt","bottom":"Projects__bottom___1I2kU","rowHeader":"Projects__rowHeader___1RIUU","rowHeaderSubtitle":"Projects__rowHeaderSubtitle___3AcDF","greyText":"Projects__greyText___3A_st","none":"Projects__none___3-9m7","projectTitle":"Projects__projectTitle___3wsh-","activity":"Projects__activity___VO2WZ","activityText":"Projects__activityText___2l9Ug","activityButton":"Projects__activityButton___2Lc_9"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/projects/components/Projects.scss
// module id = 1733
// module chunks = 0